let elems = document.querySelectorAll("a");
for (let i = 0; i < elems.length; ++i) {

  let span = elems[i].getElementsByTagName('span')[0];

  if (span) {
    if (span.classList.contains('icon-arrow')) {
      let textArray = elems[i].innerText.split(" ");
      let lastWord = textArray.pop();
      elems[i].innerHTML = textArray.join(" ") + " ";

      let innerSpan = document.createElement("span")
      innerSpan.innerHTML = lastWord;
      innerSpan.appendChild(span);
      elems[i].appendChild(innerSpan);
    }
  }

}
